import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import Filters from './Filters';
import Memberships from '../Memberships';
import BoardMembershipPermissionsSelectStep from '../BoardMembershipPermissionsSelectStep';

import styles from './BoardActions.module.scss';

const BoardActions = React.memo(
  ({
    memberships,
    labels,
    filterUsers,
    filterLabels,
    filterText,
    allUsers,
    canEdit,
    canEditMemberships,
    onlyOwnCards,
    currentUserId,
    onMembershipCreate,
    onMembershipInvite,
    onMembershipSync,
    onMembershipUpdate,
    onMembershipDelete,
    onUserToFilterAdd,
    onUserFromFilterRemove,
    onLabelToFilterAdd,
    onLabelFromFilterRemove,
    onLabelCreate,
    onLabelUpdate,
    onLabelMove,
    onLabelDelete,
    onTextFilterUpdate,
    isMobileVisible,
    showOnlyFilters,
    showOnlyMemberships,
  }) => {
    const shouldShowMemberships = !showOnlyFilters;
    const shouldShowFilters = !showOnlyMemberships;

    return (
      <div className={classNames(styles.wrapper, isMobileVisible && styles.wrapperMobileVisible)}>
        <div className={styles.actions}>
          {shouldShowMemberships && (
            <div className={styles.action}>
              <Memberships
                items={memberships}
                allUsers={allUsers}
                permissionsSelectStep={BoardMembershipPermissionsSelectStep}
                canEdit={canEditMemberships}
                onCreate={onMembershipCreate}
                onInvite={onMembershipInvite}
                onSync={onMembershipSync}
                onUpdate={onMembershipUpdate}
                onDelete={onMembershipDelete}
              />
            </div>
          )}
          {shouldShowFilters && (
            <div className={styles.action}>
              <Filters
                users={filterUsers}
                labels={filterLabels}
                filterText={filterText}
                allBoardMemberships={memberships}
                allLabels={labels}
                canEdit={canEdit}
                onlyOwnCards={onlyOwnCards}
                currentUserId={currentUserId}
                onUserAdd={onUserToFilterAdd}
                onUserRemove={onUserFromFilterRemove}
                onLabelAdd={onLabelToFilterAdd}
                onLabelRemove={onLabelFromFilterRemove}
                onLabelCreate={onLabelCreate}
                onLabelUpdate={onLabelUpdate}
                onLabelMove={onLabelMove}
                onLabelDelete={onLabelDelete}
                onTextFilterUpdate={onTextFilterUpdate}
              />
            </div>
          )}
        </div>
      </div>
    );
  }
);

BoardActions.propTypes = {
  /* eslint-disable react/forbid-prop-types */
  memberships: PropTypes.array.isRequired,
  labels: PropTypes.array.isRequired,
  filterUsers: PropTypes.array.isRequired,
  filterLabels: PropTypes.array.isRequired,
  filterText: PropTypes.string.isRequired,
  allUsers: PropTypes.array.isRequired,
  /* eslint-enable react/forbid-prop-types */
  canEdit: PropTypes.bool.isRequired,
  canEditMemberships: PropTypes.bool.isRequired,
  onlyOwnCards: PropTypes.bool.isRequired,
  currentUserId: PropTypes.string,
  onMembershipCreate: PropTypes.func.isRequired,
  onMembershipInvite: PropTypes.func,
  onMembershipSync: PropTypes.func,
  onMembershipUpdate: PropTypes.func.isRequired,
  onMembershipDelete: PropTypes.func.isRequired,
  onUserToFilterAdd: PropTypes.func.isRequired,
  onUserFromFilterRemove: PropTypes.func.isRequired,
  onLabelToFilterAdd: PropTypes.func.isRequired,
  onLabelFromFilterRemove: PropTypes.func.isRequired,
  onLabelCreate: PropTypes.func.isRequired,
  onLabelUpdate: PropTypes.func.isRequired,
  onLabelMove: PropTypes.func.isRequired,
  onLabelDelete: PropTypes.func.isRequired,
  onTextFilterUpdate: PropTypes.func.isRequired,
  isMobileVisible: PropTypes.bool,
  showOnlyFilters: PropTypes.bool,
  showOnlyMemberships: PropTypes.bool,
};

BoardActions.defaultProps = {
  isMobileVisible: false,
  showOnlyFilters: false,
  showOnlyMemberships: false,
};

export default BoardActions;
